<!-- CONTAINER -->
<div id="notifications-container">
  <!-- Tabla HEADER -->
  <div id="header-container">
    <div class="header-item notification">
      <p class="caption-01-bold">Notificación</p>
    </div>
    <div class="header-item rest">
      <p class="caption-01-bold">Agente</p>
    </div>
    <div class="header-item rest">
      <p class="caption-01-bold">Broker</p>
    </div>
    <div class="header-item rest">
      <p class="caption-01-bold">Manager</p>
    </div>
    <div class="header-item rest">
      <p class="caption-01-bold">Administración</p>
    </div>
    <div class="header-item rest">
      <p class="caption-01-bold">Secretaría/Recepción</p>
    </div>
  </div>
  <!-- Tabla HEADER END -->

  <!-- Tabla ITEM ROW -->
  <div id="rows-container">
    <!-- NOTIFICACION ITEM -->
    <div
      class="row"
      *ngFor="let item of this.notifications; let i = index"
      [ngClass]="{ 'color-1': i % 2 == 0 }"
    >
      <div class="row-item notification">
        <div class="left-container">
          <mat-slide-toggle
            color="primary"
            *ngIf="item.visibleCheckNotification"
            [checked]="item.active"
            (change)="item.active = !item.active"
          ></mat-slide-toggle>
          <p
            class="subheading-01-bold"
            [ngClass]="{ 'disabled-text': !item.active }"
          >
            {{ item.title }}
          </p>
        </div>
        <div class="right-container">
          <qr-icon
            id="tooltip-icon"
            name="question-mark"
            color="grey-500"
            [matTooltip]="item.description"
          ></qr-icon>
          <qr-button
            *ngIf="item.type == 2 || item.type == 3"
            [config]="this.buttonPropertiesDays"
            (click)="this.openDialog.emit(item)"
          ></qr-button>
        </div>
      </div>
      <!-- NOTIFICACION ITEM END -->
      <!-- AGENT ITEM -->
      <div class="row-item rest">
        <mat-checkbox
          *ngIf="item.visibleCheckAgent"
          color="primary"
          [checked]="item.agent"
          (change)="item.agent = !item.agent"
          [disabled]="!item.active"
        >
        </mat-checkbox>
      </div>
      <!-- AGENT ITEM END -->
      <!-- BROKER ITEM-->
      <div class="row-item rest">
        <mat-checkbox
          *ngIf="item.visibleCheckBroker"
          color="primary"
          [checked]="item.broker"
          (change)="item.broker = !item.broker"
          [disabled]="!item.active"
        >
        </mat-checkbox>
      </div>
      <!-- BROKER ITEM END -->
      <!-- MANAGER ITEM -->
      <div class="row-item rest">
        <mat-checkbox
          *ngIf="item.visibleCheckManager"
          [disabled]="item.visibleCheckAgent"
          color="primary"
          [checked]="item.manager"
          (change)="item.manager = !item.manager"
          [disabled]="!item.active"
        >
        </mat-checkbox>
      </div>
      <!-- MANAGER ITEM END -->
      <!-- ADMINISTRATION ITEM -->
      <div class="row-item rest">
        <mat-checkbox
          *ngIf="item.visibleCheckAdministration"
          color="primary"
          [checked]="item.administration"
          (change)="item.administration = !item.administration"
          [disabled]="!item.active"
        >
        </mat-checkbox>
      </div>
      <!-- ADMINISTRATION ITEM END -->
      <!-- SECRETARY ITEM -->
      <div class="row-item rest">
        <mat-checkbox
          *ngIf="item.visibleCheckSecretariate"
          color="primary"
          [checked]="item.secretariate"
          (change)="item.secretariate = !item.secretariate"
          [disabled]="!item.active"
        >
        </mat-checkbox>
      </div>
      <!-- SECRETARY ITEM END -->
    </div>
  </div>
  <!-- Tabla ITEM ROW END -->

  <!-- BOTBAR -->
  <div id="botbar-container">
    <qr-button [config]="buttonSave" (click)="onSave()"></qr-button>
  </div>
  <!-- BOTBAR END -->
</div>
<!-- CONTAINER END -->
